import { memo } from 'react';

import { type BaseFilterCardProps } from '~/components/Filters/FilterCard';
import { PrivatePersonFilterSelect } from '~/components/Selects/People/PrivatePersonFilterSelect';
import { PeopleFilterCard } from './PeopleFilterCard';

export const PrivatePeopleFiltersCard = memo((props: BaseFilterCardProps) => (
  <PeopleFilterCard PersonSelect={PrivatePersonFilterSelect} {...props} />
));

PrivatePeopleFiltersCard.displayName = 'PrivatePeopleFiltersCard';
